module.exports = __webpack_public_path__ + "static/media/focus-indicator.a0648e1e.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/ep3/focus-indicator.png
 ** module id = 220
 ** module chunks = 0
 **/